import * as enhancementKeys from '../component/neoviewer/apps/settings/enhancement_keys'
import cookie from "react-cookies";
import {
    cloudProvider,
    deploymentMode,
    globalUrlPrefix,
    remoteSite,
    remoteUrlPrefix,
    slideStatusEnum,
    specimenType,
    viewerType
} from "./const";
import {isDeviceIPRemote} from "./device_utils";
import {store} from "../helper/store";

export function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

export function clipValue(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

export const isCloud = () => cookie.load("deployment_mode") === deploymentMode.CLOUD;

export const isOffline = () => cookie.load("deployment_mode") === deploymentMode.OFFLINE;

export const isSuperuser = () => cookie.load('superuser') === "true";

export const getLoggedInUserId = () => parseInt(cookie.load('user_id'));

export const checkIfMobile = () => {
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(navigator.userAgent.substr(0, 4));

}


export function getFormattedLength(value) {
    let suffix;
    if (value > 1000) {
        suffix = ' mm';
        value /= 1000;
    } else if (value > 1000000) {
        suffix = ' m';
        value /= 1000000;
    } else {
        suffix = " um";
    }
    return (value.toFixed(2) + "" + suffix)
}

export function getFormattedArea(value) {
    let suffix;
    if (value > 10000) {
        suffix = ' sq.mm';
        value *= 0.000001;
    } else if (value > 1000000000000) {
        suffix = ' sq.m';
        value /= 1000000000000;
    } else {
        suffix = " sq.um";
    }
    return (value.toFixed(3) + "" + suffix)
}


export function randomstring(L) {
    var s = '';
    var randomchar = function () {
        var n = Math.floor(Math.random() * 62);
        if (n < 10) return n; //1-10
        if (n < 36) return String.fromCharCode(n + 55); //A-Z
        return String.fromCharCode(n + 61); //a-z
    }
    while (s.length < L) s += randomchar();
    return s;
}


export function otpGenerator(L) {
    var otp = '';
    var randomint = function () {
        return Math.floor(Math.random() * 10);
    }
    while (otp.length < L) otp += randomint();
    return otp;
}

export function copyStringToClipboard(str) {
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = {position: 'absolute', left: '-9999px'};
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
}

export function convertSettingsToFilter(settings) {
    if (!settings) return "";
    let cssStyle = ""
    for (let key in enhancementKeys) {
        let enhancementKey = enhancementKeys[key];
        if (enhancementKey.id in settings)
            cssStyle += enhancementKey.cssKey + "(" +
                (settings[enhancementKey.id] * enhancementKey.multiplier / enhancementKey.max) + enhancementKey.unit + ") ";
    }
    return cssStyle;
}

export const getSlideLocalPath = slide => `${slide.loc_on_machine}/scans/${slide.bucket_name}/${slide.path}`

export const getS3Url = slide => `https://${slide.bucket_name}.s3.${slide.region_name}.amazonaws.com/`;

export const getAWSCloudFrontUrl = (slide) => {
    if (slide.bucket_name === 'morphle-test') {
        // NOTE: special handling to avoid move cost for the largest bucket on our aws s3
        return `${slide.cloud_url}/`;
    }

    return `${slide.cloud_url}/`;
}

const getLocalSecureUrl = slide => `${getDeviceUrlSecure(slide)}${slide.bucket_name}/`;

export const getScanDiscUrl = slide => slideStatusCategory(slide.status) === slideStatusEnum.VIEWER_READY ? `/scan-hdd/${slide.scandrive_id}/` : '/scan-ssd/';

export const getDeviceUrl = slide => (isDeviceIPRemote(slide.device_ip) ? slide.device_ip : '') + getStateAwareUrl('') + getScanDiscUrl(slide);

export const getDeviceUrlSecure = slide => (isDeviceIPRemote(slide.device_ip) ? slide.device_ip : '') + getStateAwareUrl('') + '/secure' + getScanDiscUrl(slide);

export const getLocalUrl = slide => `${getDeviceUrl(slide)}${slide.bucket_name}/`;

export const getPrefixedUrl = (url, slide, is_tile_viewer=false) => {
    let slide_path_prefix = is_tile_viewer ? slide.tile_viewer_path : slide.path
    if (url.startsWith('pre-processed')) {
        slide_path_prefix = slide_path_prefix.replace("_mdir", "")
    }
    return (cookie.loadAll().deployment_mode === 'cloud' ? getS3Url(slide) : getLocalUrl(slide)) + slide_path_prefix + url;
}

const slideFromSecureBucket = (slide) => {
    return slide.is_secure;
    // check if slide's bucket has secure mode enabled
    // return secureBuckets.indexOf(slide.bucket_name) >= 0;
}

export const getBloodSecuredImageUrl = (imageUrl) => {
    if (cookie.loadAll().deployment_mode === deploymentMode.OFFLINE) {
        return getStateAwareUrl(`/secure${imageUrl}`)
    } else {
        return imageUrl
    }
}

export const getPrefixedUrlSecure = (url, slide) => {
    if (cookie.loadAll().deployment_mode === deploymentMode.OFFLINE) {
        return getLocalSecureUrl(slide) + (url.startsWith('pre-processed') ? slide.path.replace("_mdir", "") : slide.path) + url;
    } else if (slide.cloud_provider === cloudProvider.AWS
        && cookie.loadAll().deployment_mode === deploymentMode.CLOUD) {
        // check if slide is from bucket which has secure mode enabled
        if (slideFromSecureBucket(slide)) {
            return getAWSCloudFrontUrl(slide) + slide.path + url;
        }
    }
    return getPrefixedUrl(url, slide);
}

export const getSuffixUrl = (slide, isZoomForTiled, zStackLevel, exposureLevel) => {
    if (isZoomForTiled) {
        if (zStackLevel)
            return `stack/S${zStackLevel}`;
        if (exposureLevel && exposureLevel !== 'HDR')
            return `exposure_stack/tiled/${exposureLevel}`;
        return 'tiled';
    }
    if (exposureLevel && exposureLevel !== 'HDR')
        return `exposure_stack/stitched/${exposureLevel}/{z}/x{x}y{y}.${slide.img_type}`;
    return `stitched/{z}/x{x}y{y}.${slide.img_type}`;
}

export const getPreviewUrl = (url, slide) => {
    if (!isCloud()) {
        url = url.replace("/static/", "");
        return `${getDeviceUrl(slide)}${url}`;
    } else {
        let parts = url.split("/");
        let previewPath = url;
        if (parts.length >= 2) {
            previewPath = `${parts[parts.length-2]}/${parts[parts.length-1]}`;
        }
        let slide_path = slide.path;
        if (slide_path.endsWith("_mdir/")) {
            slide_path = slide_path.replace("_mdir/", "");    
        }
        previewPath = `${slide.cloud_url}/${slide_path}${previewPath}`;
        return previewPath;
    }
}

export const getBarcodeUrl = (slide, is_cloud) => {
    let labelPath = slide.preview_image;
    if (labelPath.includes('selection_marked')) {
        return getPreviewUrl(labelPath.replace('selection_marked', 'barcode_crop'), slide);
    } else {
        return getPreviewUrl(labelPath.replace('stitched_small_viewer', 'barcode_crop'), slide);
    }
}

export function generateLiveModePrefixCode() {
    return Math.floor(Math.random() * 9000) + 1000;
}

export function generateLiveModeSuffixCode() {
    let randomNames = ["Alpha", "Beta", "Gamma", "Delta", "Phi", "Tilda", "Epsilon", "Kappa", "Lambda"];
    let randInt = parseInt((Math.random() * randomNames.length));
    let randInt2 = parseInt((Math.random() * randomNames.length * 20));
    return randomNames[randInt] + Date.now() + randInt2;
}

export function fullColorHex(r, g, b) {
    var red = rgbToHex(r);
    var green = rgbToHex(g);
    var blue = rgbToHex(b);
    return "#" + red + green + blue;
}

export function rgbToHex(rgb) {
    var hex = Number(rgb).toString(16);
    if (hex.length < 2) {
        hex = "0" + hex;
    }
    return hex;
}

export function hsvToRgb(h, s, v) {
    let r, g, b, i, f, p, q, t;
    if (arguments.length === 1) {
        s = h.s;
        v = h.v;
        h = h.h;
    }
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0:
            r = v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = v;
            b = p;
            break;
        case 2:
            r = p;
            g = v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = v;
            break;
        case 4:
            r = t;
            g = p;
            b = v;
            break;
        case 5:
            r = v;
            g = p;
            b = q;
            break;
        default:
            r = 0;
            g = 0;
            b = 0;
            break;
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}

export function getPosString(pos) {
    return "x" + pos["xPosition"] + " y" + pos['yPosition'] + " z" + pos['zPosition'];
}

export const round = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);

export const linkViewer = (slide, ext, shouldOpenInNewTab = false) => {
    openEndPoint(getScanURL(slide, ext), shouldOpenInNewTab, true)
}

export const linkViewerRedirect = (slide, ext, shouldOpenInNewTab = false) => {
    return openEndPointRedirect(getScanURL(slide, ext), shouldOpenInNewTab, false)
}

export const getSplitViewerLink = (slides, ext) => {
    let initSlideId = slides[0].id;
    let urlPostFix = slides.reduce((urlPart, slide) => `${urlPart}#slideId=${slide.id}`, "")

    return (`/gamma/${initSlideId}?${urlPostFix}`);
}

export const getScanURL = (slide, ext) => {
    if ((slide.specimen_type === "bone_marrow" || slide.specimen_type === specimenType.BLOOD.toLowerCase()) &&
        slide.viewer_type !== viewerType.TISSUE) {
        return "/blood/" + slide.id
    } else if (slide.only_tiling) {
        return "/server/v3/tissue/" + slide.morphle_id + "/tiling/"
    } else {
        return `/gamma/${slide.id}${ext || ''}`
    }
}

export const openInNewTab = (url) => window.open(window.location.origin + getStateAwareUrl(url), '_blank')

export const openEndPoint = (endpoint, newTab, useGlobalUrlPrefix) => newTab ? openInNewTab(`${endpoint}`) :
    window.location.href = window.location.origin + useGlobalUrlPrefix ? `${globalUrlPrefix}${endpoint}` : getStateAwareUrl(`${endpoint}`);

export const openEndPointRedirect = (endpoint, newTab, useGlobalUrlPrefix) => {
    if (newTab) {
        openInNewTab(`${endpoint}`);
        return null;
    } else {
        return useGlobalUrlPrefix ? `${globalUrlPrefix}${endpoint}` : endpoint;
    }
}

export const URLify = (string) => string.trim().replace(/\s/g, '%20');

export const isNumber = value => typeof value === 'number' && isFinite(value);

export const limitString = (string, maxCharacters) =>
    `${string.slice(0, maxCharacters)}${string.length > maxCharacters - 3 ? '...' : ''}`

export const getFileExtension = (filename) => filename.split('.').pop();

export const radianToDegree = (pi) => pi * 180 / Math.PI;

export const degreeToRadian = (degree) => degree * Math.PI / 180;

export const limitNumber = (number, min, max) => Math.min(Math.max(number, min), max);

export const isArrayContentEqual = (array1, array2) =>
    array1.length === array2.length && array1.every((element, index) => element === array2[index]);

export const isArrayEqual = (arr1, arr2) => {
    if (!arr1 || !arr2) return false

    arr1?.sort()
    arr2?.sort()

    return arr1.length === arr2.length &&
        arr1.reduce((prev, curr, idx) => prev && curr === arr2[idx], true)
}

export const daysToHours = days => days * 24;

export const hoursToMinutes = hours => hours * 60;

export const minutesToSeconds = minutes => minutes * 60;

export const secondsToMilliseconds = seconds => seconds * 1000;

export const daysToMilliseconds = days => secondsToMilliseconds(minutesToSeconds(hoursToMinutes(daysToHours(days))));

export const notZero = (number) => number !== 0 && number !== '0';

export const isNull = value => value === undefined || value === null;

export const notNull = value => !isNull(value);

export const isTrue = (value) => value === true || (value !== false && notZero(value) && notNull(value) &&
    ['true', 'yes', 'y', 't', 'on', 'enable', 'enabled', 'ok'].includes(value.toLowerCase()));

export const isEmptyObject = (obj) => {
	return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const isEmptyArray = (arr) => {
	return Array.isArray(arr) && arr.length === 0;
};

export const calculateClientHeightRatio = (ratio, maxHeight) =>
    Math.floor((maxHeight || document.documentElement.clientHeight) * ratio);

export const calculateClientWidthRatio = (ratio, maxWidth) =>
    Math.floor((maxWidth || document.documentElement.clientWidth) * ratio);

export const cropCanvas = (sourceCanvas, left, top, width, height) => {
    let destCanvas = document.createElement('canvas');
    destCanvas.width = width;
    destCanvas.height = height;
    destCanvas.getContext("2d").drawImage(
        sourceCanvas,
        left, top, width, height,       // source rect with content to crop
        0, 0, width, height);   // newCanvas, same size as source rect
    return destCanvas;
}

export const isWhitePixel = pixelData => pixelData.reduce((val, pixel) => val && pixel === 255, true);

export const getSupportedSpecimenType = (SPECIMEN, supportedSpecs, removeBlood) => {

    if (isNull(supportedSpecs)) return SPECIMEN;
    let specimens_ = []
    if (notNull(supportedSpecs) && (supportedSpecs || {}).length > 0) {
        supportedSpecs.forEach((index) => {
            specimens_.push(index);
        })
    }

    Object.keys(SPECIMEN).forEach((specimen) => {
        if (!(specimens_.includes(specimen) || specimens_.includes(SPECIMEN[specimen]))) {
            delete SPECIMEN[specimen]
        }
    });

    if (removeBlood) {
        delete SPECIMEN[specimenType.BLOOD]
    }

    return SPECIMEN;
}

// Return the sorted copy of the array
export const sorted = (array, fun) => array.slice().sort(fun);

export const bytesToHumanReadableSize = (bytes) => {
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)), 10);
    const size = bytes / (1000 ** i);
    return `${size.toFixed(2)} ${units[i]}`;
};

// UUID v4
export const uuid = () => ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));

export const debounce = (func, time) => {
    let time_int = time || 100; // 100 by default if no param
    let timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time_int, event);
    };
}

export const isEnterPressed = event => event.key === 'Enter';

/**
 * @param {Object} event event object
 * @param {Boolean} currCapsLockState current state of CapsLock
 * @returns {Boolean} - CapsLock Activation State
 * **/
export const checkCapsLockOn = (event, currCapsLockState) => {
    if (event.keyCode === 20) {
        return !currCapsLockState
    } else if (typeof event.getModifierState === 'function') {
        return event.getModifierState("CapsLock");
    } else {
        return currCapsLockState;
    }
}

export const getUperpixel = () => {
    const activeMapId = store.getState().gammaStateReducer.activeMapId;
    return store.getState().mapsStateReducer[activeMapId].slide.uperpixel;
}

export const colorArrayToRGB = color => `rgb(${color?.[0] || 255}, ${color?.[1] || 255}, ${color?.[2] || 255})`;
export const getKeyByValue = (object, value) => Object.keys(object).find(key => object[key] === value);

export const limitNumWithinMinMax = (num, min, max) => Math.min(max, Math.max(num, min))

export const getEuclideanDistance = ([point1, point2]) => {
    const x = point1[0] - point2[0];
    const y = point1[1] - point2[1];
    return Math.sqrt(x * x + y * y);
}

export const getDeviceSeries = (deviceType) => {
    if (deviceType.includes("HEMOLENS")) return "HEMOLENS";
    else if (deviceType.includes("MORPHOLENS")) return "MORPHOLENS";
}
export const checkNotificationOpen = (notificationKey) => store.getState().gammaStateReducer.notifications.some(notification => notification.key === notificationKey ? true : null);

export const stringForAvatar = (name, is_group) => {
    if (isNull(name)) name = '';
    const display_name = is_group ? `Gr` : name.trim(' ').length === 0 ? '' : `${name.split(' ')[0][0]?.toUpperCase()}${name.split(' ')[1]?.length > 0 ? name.split(' ')[1][0]?.toUpperCase() : ''}`;
    return {
        sx: {
            bgcolor: is_group ? "orange" : "gray",
        },
        children: display_name,
    }
}

export const copyToClipboard = (text) => {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}

export const isRunningFromSite = () => {
    return remoteSite.includes(window.location?.hostname)
}

export const getStateAwareUrl = (url) => {
    return isRunningFromSite() ? remoteUrlPrefix + url : url
}

export const getRealRemoteURL = (url) => {
    return isRunningFromSite() ? `https://${process.env.REACT_APP_REMOTE_URL}${isTrue(process.env.REACT_APP_IS_CLOUD) ? '' : `.${process.env.REACT_APP_REMOTE_SERVER}`}.morphlelabs.com${url}` : url;
}

export const joinPath = (...segments) => {
    segments.forEach((segment, index) => {
        if (segment.startsWith('/') && index !== 0) {
            // Don't modify first segment if it starts with /, to support relative path
            segments[index] = segment.slice(1)
        }
        if (segment.endsWith('/')) {
            segments[index] = segment.slice(0, -1)
        }
    })
    return segments.join('/');
}

export const changeGammaViewUrl = (props, prevSlideId, slideId, replace = false) => {
    const url = window.location.pathname + window.location.search;
    const new_url = url.replace(prevSlideId, slideId);
    if (replace) {
        props.history.replace(new_url)
    } else {
        props.history.push(new_url)
    }
}
export const slideStatusCategory = (status) => {
    if (status >= 0 && status <= 200) return slideStatusEnum.SCANNING;
    if (status > 200 && status <= 400) return slideStatusEnum.VIEWER_READY;
    if (status > 400 && status <= 600) return slideStatusEnum.ERRORED;
    else return slideStatusEnum.UNKNOWN;
}
export const chatAvatarColorList = [
    "#65347a",
//     will be added later
];

export const getRandomChatAvatarColor = () => {
    return chatAvatarColorList[Math.floor(Math.random() * chatAvatarColorList.length)];
};